import script from "./TeamColorPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamColorPicker.vue?vue&type=script&setup=true&lang=ts"

import "./TeamColorPicker.vue?vue&type=style&index=0&id=0cc38f86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc38f86"]])

export default __exports__